import { Button } from 'src/shared/components/ui'
import { ThumbsUp } from 'lucide-react'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { cn } from 'src/shared/components/ui/utils'

export const ProductLikeButton = ({
  likeCount,
  isLiked,
  isAuthenticated,
  onToggleLike,
  isPending,
  variant = 'mobile',
}: {
  likeCount: number
  isLiked: boolean
  isAuthenticated: boolean
  onToggleLike: () => void
  isPending: boolean
  variant?: 'mobile' | 'desktop'
}) => {
  const { t } = useLocalization()

  const gap = variant === 'mobile' ? 'gap-1' : 'gap-2'
  const width = variant === 'desktop' ? 'w-fit' : ''

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onToggleLike}
      disabled={isPending || !isAuthenticated}
      className={cn('flex items-center', gap, width, isLiked && 'text-primary')}
    >
      <ThumbsUp className={cn('w-4 h-4', isLiked && 'fill-current')} />
      {likeCount === 0
        ? t('Be the first to like', 'Bli den första att gilla')
        : t(
            `${likeCount} ${likeCount === 1 ? 'like' : 'likes'}`,
            `${likeCount} ${likeCount === 1 ? 'gillar' : 'gillar'}`
          )}
    </Button>
  )
}
